import React from 'react';
import { ArrowLeft, Lock, Download, FileText, Trash2, AlertTriangle } from 'lucide-react';
import ResumenTab  from './ResumenTab';
import DetalleTab  from './DetalleTab';
import ErroresTab  from './ErroresTab';

export default function DetalleIR13({
  ir13, detalles, activeTab, onTabChange,
  onBack, onCerrar, onEliminar, onExportCSV, onExportTXT,
  loading
}) {
  const cerrado     = ir13.estado === 'cerrado';
  const errores     = detalles.filter(d => !d.tiene_datos || !d.rnc_cedula?.trim()).length;

  const TABS = [
    { id: 'resumen',  label: 'Resumen'  },
    { id: 'detalle',  label: 'Detalle'  },
    { id: 'errores',  label: 'Errores', badge: errores },
  ];

  return (
    <div className="space-y-4">

      {/* Top bar */}
      <div className="flex items-center gap-3 flex-wrap">
        <button
          onClick={onBack}
          className="flex items-center gap-1.5 px-2.5 py-1.5 text-sm text-gray-500 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <ArrowLeft size={14} />
          Volver
        </button>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h2 className="text-base font-bold text-gray-900">IR-13 — Año {ir13.anio}</h2>
            {cerrado ? (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
                <Lock size={10} /> Cerrado
              </span>
            ) : (
              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
                Borrador
              </span>
            )}
          </div>
          <p className="text-xs text-gray-400">{ir13.total_empleados} empleados · {ir13.incluir_inactivos ? 'incluye inactivos' : 'solo activos'}</p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 flex-wrap">
          <button
            onClick={onExportTXT}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs border border-gray-200 rounded-lg hover:bg-gray-50 text-gray-600 transition-colors"
          >
            <FileText size={13} />
            TXT
          </button>
          <button
            onClick={onExportCSV}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs border border-gray-200 rounded-lg hover:bg-gray-50 text-gray-600 transition-colors"
          >
            <Download size={13} />
            CSV
          </button>

          {!cerrado && (
            <>
              <button
                onClick={onCerrar}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold transition-colors"
              >
                <Lock size={13} />
                Cerrar Declaración
              </button>
              <button
                onClick={onEliminar}
                className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs border border-red-200 text-red-600 rounded-lg hover:bg-red-50 transition-colors"
              >
                <Trash2 size={13} />
              </button>
            </>
          )}
        </div>
      </div>

      {/* Warning si hay errores y no está cerrado */}
      {!cerrado && errores > 0 && (
        <div className="flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
          <AlertTriangle size={14} className="text-amber-600 flex-shrink-0" />
          <p className="text-xs text-amber-700">
            Hay <strong>{errores}</strong> empleado{errores !== 1 ? 's' : ''} con datos incompletos. Revisa la pestaña "Errores" antes de cerrar.
          </p>
        </div>
      )}

      {/* Tabs */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div className="flex border-b border-gray-200 px-1 pt-1">
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
              {tab.badge > 0 && (
                <span className="ml-1 inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold bg-red-500 text-white rounded-full">
                  {tab.badge}
                </span>
              )}
            </button>
          ))}
        </div>

        <div className="p-4">
          {loading ? (
            <div className="flex items-center justify-center py-16">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
          ) : (
            <>
              {activeTab === 'resumen' && <ResumenTab ir13={ir13} detalles={detalles} />}
              {activeTab === 'detalle' && <DetalleTab detalles={detalles} />}
              {activeTab === 'errores' && <ErroresTab detalles={detalles} />}
            </>
          )}
        </div>
      </div>

    </div>
  );
}
